import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
import { cardHeaderStyling } from './styling';
export function CardHeader({ children, className, padding, ...props }) {
    return (_jsx("div", { className: cn(cardHeaderStyling({ padding }), className), ...props, children: children }));
}
